<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/CountryBase' }">国别基础信息库</el-breadcrumb-item>
            <el-breadcrumb-item>{{countryTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <el-form ref="formData" :model="formData" label-width="80px">
            <el-form-item label="国家名称*" v-if="countryDisabled">{{countryName}}</el-form-item>
            <el-form-item label="国家名称*" v-else>
              <el-select
                placeholder="选择地区"
                v-model="formData.area_id"
                filterable
                clearable
                :disabled="countryDisabled"
              >
                <el-option
                  v-for="item in addressSelectData"
                  :key="item.id"
                  :label="item.full_area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="国旗*">
              <img v-if="formData.national_flag" :src="formData.national_flag" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.national_flag"
                ref="nationalFlag"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData"
                :imageUrl="imageUrl"
                :fileList="fileList1"
              ></uploadFlie>
              <el-button v-if="formData.national_flag" type="primary" @click="formData.national_flag='' ">编辑</el-button>
            </el-form-item>

            <el-form-item label="国徽*">
              <img v-if="formData.national_emblem" :src="formData.national_emblem" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.national_emblem"
                ref="nationalEmblem"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData"
                :imageUrl="imageUrl"
                :fileList="fileList2"
              ></uploadFlie>
              <el-button v-if="formData.national_emblem" type="primary" @click="formData.national_emblem='' ">编辑</el-button>
            </el-form-item>

            <el-form-item label="丝路国家">
              <el-radio v-model="formData.silk_road_country" label="是"></el-radio>
              <el-radio v-model="formData.silk_road_country" label="否"></el-radio>
            </el-form-item>

            <el-form-item label="地理环境-区域位置">
              <el-input v-model="formData.regional_location" type="textarea" placeholder="请输入区域位置"></el-input>
            </el-form-item>
            <el-form-item label="地理环境-地理位置">
              <el-input
                v-model="formData.geographical_position"
                type="textarea"
                placeholder="请输入地理位置"
              ></el-input>
            </el-form-item>
            <el-form-item label="地理环境-国土面积">
              <el-input v-model="formData.land_area" type="textarea" placeholder="请输入国土面积"></el-input>
            </el-form-item>
            <el-form-item label="地理环境-地形地貌">
              <el-input
                v-model="formData.topographical_features"
                type="textarea"
                placeholder="请输入地形地貌"
              ></el-input>
            </el-form-item>
            <el-form-item label="地理环境-气候特征">
              <el-input
                v-model="formData.climatic_characteristics"
                type="textarea"
                placeholder="请输入气候特征"
              ></el-input>
            </el-form-item>
            <el-form-item label="地理环境-自然资源">
              <el-input v-model="formData.natural_resources" type="textarea" placeholder="请输入自然资源"></el-input>
            </el-form-item>
            <el-form-item label="时区*">
              <el-select v-model="formData.time_zone" placeholder="请选择时区">
                <el-option
                  v-for="item in timeZoneSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行政区划-首都" v-if="countryDisabled">{{countryCapital}}</el-form-item>
            <el-form-item label="行政区划-首都*" v-else>
              <el-select placeholder="选择首都" v-model="formData.capital_area_id" filterable clearable>
                <el-option
                  v-for="item in addressSelectData"
                  :key="item.id"
                  :label="item.full_area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行政区划-区划">
              <el-input v-model="formData.districts" type="textarea" placeholder="请输入行政区划"></el-input>
            </el-form-item>
            <el-form-item label="政治环境-政治体制">
              <el-input v-model="formData.political_system" type="textarea" placeholder="请输入政治体制"></el-input>
            </el-form-item>
            <el-form-item label="政治环境-主要政党及领导人">
              <el-input v-model="formData.party_leaders" type="textarea" placeholder="请输入主要政党及领导人"></el-input>
            </el-form-item>
            <el-form-item label="政治环境-司法">
              <el-input v-model="formData.judicial" type="textarea" placeholder="请输入司法"></el-input>
            </el-form-item>
            <el-form-item label="主要恐怖组织">
              <el-input
                v-model="formData.terrorist_organizations"
                type="textarea"
                placeholder="请输入主要恐怖组织"
              ></el-input>
            </el-form-item>
            <el-form-item label="主要分离组织">
              <el-input v-model="formData.separatist_group" type="textarea" placeholder="请输入主要分离组织"></el-input>
            </el-form-item>
            <el-form-item label="主要政府武装">
              <el-input
                v-model="formData.government_armed_forces"
                type="textarea"
                placeholder="请输入主要政府武装"
              ></el-input>
            </el-form-item>
            <el-form-item label="国际关系-与中国关系">
              <el-input
                v-model="formData.relations_with_china"
                type="textarea"
                placeholder="请输入与中国关系"
              ></el-input>
            </el-form-item>
            <el-form-item label="国际关系-与邻国关系">
              <el-input
                v-model="formData.relations_with_neighboring_countries"
                type="textarea"
                placeholder="请输入与邻国关系"
              ></el-input>
            </el-form-item>
            <el-form-item label="国际关系-与西方国家关系">
              <el-input
                v-model="formData.relations_with_western_countries"
                type="textarea"
                placeholder="请输入与西方国家关系"
              ></el-input>
            </el-form-item>
            <el-form-item label="求助电话-火匪急求助电话">
              <el-input v-model="formData.fire_police_num" type="textarea" placeholder="请输入火匪急求助电话"></el-input>
            </el-form-item>
            <el-form-item label="求助电话-其他求助电话">
              <el-input v-model="formData.help_line" type="textarea" placeholder="请输入其他求助电话"></el-input>
            </el-form-item>
            <el-form-item label="时差">
              <el-input v-model="formData.time_difference" type="textarea" placeholder="请输入时差"></el-input>
            </el-form-item>
            <el-form-item label="相关官方网站">
              <el-input v-model="formData.offical_website" type="textarea" placeholder="请输入相关官方网站"></el-input>
            </el-form-item>
            <el-form-item label="出入境注意事项">
              <el-input
                v-model="formData.entry_exit_points_for_attention"
                type="textarea"
                placeholder="请输入出入境注意事项"
              ></el-input>
            </el-form-item>
            <el-form-item label="签证信息">
              <el-input v-model="formData.visa_info" type="textarea" placeholder="请输入签证信息"></el-input>
            </el-form-item>
            <el-form-item label="电源">
              <el-input v-model="formData.power_info" type="textarea" placeholder="请输入电源"></el-input>
            </el-form-item>
            <el-form-item label="通信">
              <el-input v-model="formData.communication_info" type="textarea" placeholder="请输入通信"></el-input>
            </el-form-item>
            <el-form-item label="中国投资情况">
              <el-input v-model="formData.china_investment" type="textarea" placeholder="请输入中国投资情况"></el-input>
            </el-form-item>
            <el-form-item label="大使馆地址">
              <el-input v-model="formData.embassy_addresse" type="textarea" placeholder="请输入大使馆地址"></el-input>
            </el-form-item>
            <el-form-item label="大使馆领区">
              <el-input v-model="formData.embassy_area" type="textarea" placeholder="请输入大使馆领区"></el-input>
            </el-form-item>
            <el-form-item label="大使馆联系方式-领保电话/办公电话">
              <el-input
                v-model="formData.embassy_telephone"
                type="textarea"
                placeholder="请输入领保电话/办公电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="大使馆联系方式-大使馆传真">
              <el-input v-model="formData.embassy_fax" type="textarea" placeholder="请输入大使馆传真"></el-input>
            </el-form-item>
            <el-form-item label="大使馆办公时间">
              <el-input
                v-model="formData.embassy_work_time"
                type="textarea"
                placeholder="请输入大使馆办公时间"
              ></el-input>
            </el-form-item>
            <el-form-item label="大使馆办公地址">
              <el-input
                v-model="formData.embassy_work_address"
                type="textarea"
                placeholder="请输入大使馆办公地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="大使馆官方网站">
              <el-input v-model="formData.embassy_website" type="textarea" placeholder="请输入大使馆官方网站"></el-input>
            </el-form-item>
            <el-form-item label="大使馆签证处-办公时间">
              <el-input
                v-model="formData.embassy_visa_work_time"
                type="textarea"
                placeholder="请输入大使馆签证处办公时间"
              ></el-input>
            </el-form-item>
            <el-form-item label="大使馆签证处-办公地址">
              <el-input
                v-model="formData.embassy_visa_work_address"
                type="textarea"
                placeholder="请输入大使馆签证处办公地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="大使馆签证处-办公电话">
              <el-input
                v-model="formData.embassy_visa_telephone"
                type="textarea"
                placeholder="请输入大使馆签证处办公电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆领区">
              <el-input
                v-model="formData.general_consulate_area"
                type="textarea"
                placeholder="请输入总领馆领区"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆联系方式-领保电话/办公电话">
              <el-input
                v-model="formData.general_consulate_telephone"
                type="textarea"
                placeholder="请输入总领馆领保电话/办公电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆联系方式-传真">
              <el-input
                v-model="formData.general_consulate_fax"
                type="textarea"
                placeholder="请输入总领馆传真"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆办公时间">
              <el-input
                v-model="formData.general_consulate_work_time"
                type="textarea"
                placeholder="请输入总领馆办公时间"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆办公地址">
              <el-input
                v-model="formData.general_consulate_work_address"
                type="textarea"
                placeholder="请输入总领馆办公地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆官方网站">
              <el-input
                v-model="formData.general_consulate_website"
                type="textarea"
                placeholder="请输入总领馆官方网站"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆证件办公室-办公时间">
              <el-input
                v-model="formData.general_consulate_certificates_office_telephone"
                type="textarea"
                placeholder="请输入总领馆证件办公室办公时间"
              ></el-input>
            </el-form-item>
            <el-form-item label="总领馆证件办公室-办公电话">
              <el-input
                v-model="formData.general_consulate_certificates_office_work_time"
                type="textarea"
                placeholder="请输入总领馆证件办公室办公时间"
              ></el-input>
            </el-form-item>
            <el-form-item label="旅游">
              <el-input v-model="formData.travel_info" type="textarea" placeholder="请输入旅游"></el-input>
            </el-form-item>
            <el-form-item label="国家重要节假日">
              <el-input
                v-model="formData.national_holidays"
                type="textarea"
                placeholder="请输入国家重要节假日"
              ></el-input>
            </el-form-item>
            <el-form-item label="主要城市及人口分布">
              <el-input
                v-model="formData.major_city_and_population"
                type="textarea"
                placeholder="请输入主要城市及人口分布"
              ></el-input>
            </el-form-item>
            <el-form-item label="经济-概况">
              <el-input v-model="formData.economics_survey" type="textarea" placeholder="请输入经济概况"></el-input>
            </el-form-item>
            <el-form-item label="经济-失业率">
              <el-input
                v-model="formData.economics_unemployment_rate"
                type="textarea"
                placeholder="请输入失业率"
              ></el-input>
            </el-form-item>
            <el-form-item label="经济-货币信息">
              <el-input
                v-model="formData.economics_currency "
                type="textarea"
                placeholder="请输入货币信息"
              ></el-input>
            </el-form-item>
            <el-form-item label="经济-工业">
              <el-input v-model="formData.economics_industry" type="textarea" placeholder="请输入工业"></el-input>
            </el-form-item>
            <el-form-item label="经济-农业">
              <el-input
                v-model="formData.economics_agriculture"
                type="textarea"
                placeholder="请输入农业"
              ></el-input>
            </el-form-item>
            <el-form-item label="文化环境-语言">
              <el-input v-model="formData.language" type="textarea" placeholder="请输入语言"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-宗教">
              <el-input v-model="formData.religion" type="textarea" placeholder="请输入宗教"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-风俗">
              <el-input v-model="formData.customs" type="textarea" placeholder="请输入风俗"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-服饰">
              <el-input v-model="formData.clothes" type="textarea" placeholder="请输入服饰"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-饮食">
              <el-input v-model="formData.food" type="textarea" placeholder="请输入饮食"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-礼仪">
              <el-input v-model="formData.ceremony" type="textarea" placeholder="请输入礼仪"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-人口">
              <el-input v-model="formData.population" type="textarea" placeholder="请输入人口"></el-input>
            </el-form-item>
            <el-form-item label="文化环境-民族">
              <el-input v-model="formData.nation" type="textarea" placeholder="请输入民族"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button type="primary" v-if="submit" @click="newSubmit">提交并新建</el-button>
              <el-button @click="goToCountryBase">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadFlie from "@/components/unloadFile/index";
import timeZoneSelect from "./time_zone";
import api from "../api";
import tokenService from "@/utils/services/token_service"

export default {
  components: { uploadFlie },
  data() {
    return {
      countryTitle: "新增条目", //标题
      countryDisabled: false, //修改状态禁用
      countryName: "", //国家名称
      countryCapital: "", //国家首都
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "country"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      currentFile: null, //当前文件
      addressSelectData: null, //地址控件选择
      submit: true, //提交状态
      newConstruction: false, //返回状态
      fileList1: [], //文件列表
      fileList2: [], //文件列表
      timeZoneSelect: [], //时区
      ruleForm: {
        dialogImageUrl: "" //预览地址
      },
      formData: {
        //参数
        area_id: "",
        national_flag: "",
        national_emblem: "",
        silk_road_country: "",
        regional_location: "",
        geographical_position: "",
        land_area: "",
        topographical_features: "",
        climatic_characteristics: "",
        natural_resources: "",
        time_zone: "",
        capital_area_id: "",
        political_system: "",
        party_leaders: "",
        judicial: "",
        terrorist_organizations: "",
        separatist_group: "",
        government_armed_forces: "",
        relations_with_china: "",
        relations_with_neighboring_countries: "",
        relations_with_western_countries: "",
        fire_police_num: "",
        help_line: "",
        time_difference: "",
        offical_website: "",
        entry_exit_points_for_attention: "",
        visa_info: "",
        power_info: "",
        communication_info: "",
        china_investment: "",
        embassy_addresse: "",
        embassy_area: "",
        embassy_telephone: "",
        embassy_fax: "",
        embassy_work_time: "",
        embassy_work_address: "",
        embassy_website: "",
        embassy_visa_work_time: "",
        embassy_visa_work_address: "",
        embassy_visa_telephone: "",
        general_consulate_area: "",
        general_consulate_telephone: "",
        general_consulate_fax: "",
        general_consulate_work_time: "",
        general_consulate_work_address: "",
        general_consulate_website: "",
        general_consulate_certificates_office_telephone: "",
        general_consulate_certificates_office_work_time: "",
        nutravel_infoll: "",
        national_holidays: "",
        major_city_and_population: "",
        economics_survey: "",
        economics_unemployment_rate: "",
        economics_currency: "",
        economics_industry: "",
        economics_agriculture: "",
        language: "",
        religion: "",
        customs: "",
        clothes: "",
        food: "",
        ceremony: "",
        population: "",
        nation: ""
      }
    };
  },
  created() {
    this.initCommonData();
    this.timeZoneSelect = timeZoneSelect;//时区
    let _token = tokenService.getToken();
    if (_token) {
      this.imageData.sid = _token
    }

    //如果有countryId 则是修改状态
    if (this.$route.query.countryId) {
      this.infoCommonData()
      this.countryName = this.$route.query.countryName;
      this.countryCapital = this.$route.query.countryCapital;
      this.formData.area_id = this.$route.query.countryId;
      this.countryTitle = "修改条目";
      // this.countryDisabled = true;
      this.submit = false;
    }
  },
  methods: {
    // infoCommonData
    infoCommonData() {
      let data = {
        id: this.$route.query.countryId,
      };
      api
        .countryInfoShow(data)
        .then(res => {
          this.formData = res.info
          if(this.formData.silk_road_country == 1) {
            this.formData.silk_road_country = "是"
          }else {
            this.formData.silk_road_country = "否"
          }
          this.fileList1.push({ url: this.formData.national_flag})
          this.fileList2.push({ url: this.formData.national_emblem})
        })
        .catch(err => {
          this.$message(err);
        });
    },
    async initCommonData() {
      // 获取城市列表
      this.$commFunc.getAreaList().then(resData => {
        this.areaDataLoaded = true;
        this.addressSelectData = resData;
      });
    },

    // 提交并新建表单
    newSubmit() {
      let data = this.formData;
      if(data.national_flag == "") {
        data.national_flag = this.$refs.nationalFlag.UploadImageUrl;
      }
      if(data.national_emblem == "") {
        data.national_emblem = this.$refs.nationalEmblem.UploadImageUrl;
      }

      // Switch 参数转换
      if (data.silk_road_country == "是") {
        data.silk_road_country = 1;
      }
      if (data.silk_road_country == "否") {
        data.silk_road_country = 0;
      }

      // 编辑状态
      if (this.$route.query.countryId) {
        delete this.formData.area_name;
        delete this.formData.capital_name;
        delete this.formData.guide_status;

        delete this.formData.guide_risk_descr;
        delete this.formData.guide_public_risk;
        delete this.formData.guide_chinese_risk;
        delete this.formData.guide_key_area_risk;

        delete this.formData.guide_border_rule;
        delete this.formData.guide_useful_information;
        delete this.formData.guide_emergency_information;

        delete this.formData.area_id; //删除创建字段
        data.id = this.$route.query.countryId; //添加国家id
        api
          .countryInfoEdit(data)
          .then(res => {
            if (res.error_code == 0) {

              this.$message({
                message: "修改成功！",
                type: "success"
              });

              this.formData = {};
              this.submit = true;
              // this.$refs.nationalFlag.clearImg(); //清空国旗图片
              // this.$refs.nationalEmblem.clearImg(); //清空国徽图片
              if (this.newConstruction) {
                //修改成功 跳转原页面
                this.goToCountryBase();
                this.newConstruction = false;
              }
            }
          })
          // .catch(err => {
          //   this.$message.error(err.error_message);
          // });
      } else {
        // 新增参数
        api
          .countryInfoCreate(data)
          .then(res => {
            if (res.error_code == 0) {

              this.$message({
                message: "新建成功！",
                type: "success"
              });
              
              this.formData = {};
              this.submit = true;
              // this.$refs.nationalFlag.clearImg();
              // this.$refs.nationalEmblem.clearImg();
              if (this.newConstruction) {
                this.goToCountryBase();
                this.newConstruction = false;
              }
            }
          })
          // .catch(err => {
          //    this.$message.error(err.error_message);
          // });
      }
    },

    // 提交表单
    onSubmit() {
      this.newConstruction = true;
      this.newSubmit();
    },

    // 取消跳转原页面
    goToCountryBase() {
      this.$router.push({
        name: "countryBase"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
.headContainer {
  height: 100vh;
  overflow-x: hidden;
}
</style>